import { render, staticRenderFns } from "./mechanism_form.vue?vue&type=template&id=de725072&scoped=true&"
import script from "./mechanism_form.vue?vue&type=script&lang=js&"
export * from "./mechanism_form.vue?vue&type=script&lang=js&"
import style0 from "./mechanism_form.vue?vue&type=style&index=0&id=de725072&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de725072",
  null
  
)

export default component.exports